module.exports = __webpack_public_path__ + "static/media/no-wifi.3ef146b1.svg";